module.exports = __webpack_public_path__ + "img/bg_box_top.471ae9c8.png";